import React from 'react';
import LegalLayout, { LegalSection } from '../../components/LegalLayout';

export default function PolitiqueConfidentialiteEN() {
  return (
    <LegalLayout title="Privacy policy" lastUpdated="January 1, 2025">
      <div style={{ background: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px' }}>
        <p style={{ color: '#ffc107', fontSize: '13px', margin: 0 }}>
          <strong>Information only:</strong> This is a summary translation for information purposes only.
          The French version is the sole legally binding version. In case of discrepancy, the French version shall prevail.
        </p>
      </div>
      <LegalSection title="1. Data collected">
        <p>Kurso collects the following personal data:</p>
        <ul>
          <li><strong>Account data:</strong> first name, email address, password (hashed)</li>
          <li><strong>Usage data:</strong> courses generated, quiz results, XP, badges, learning streak</li>
          <li><strong>Assessment data:</strong> answers provided in the Kurso assessment (Bilan)</li>
          <li><strong>Payment data:</strong> handled exclusively by Stripe — Kurso does not store card details</li>
          <li><strong>Analytics:</strong> usage statistics via Mixpanel (only with your consent)</li>
        </ul>
      </LegalSection>
      <LegalSection title="2. Purpose and legal basis">
        <p>Your data is processed for the following purposes:</p>
        <ul>
          <li>Providing the Kurso service (contractual necessity)</li>
          <li>Personalising your learning experience (legitimate interest)</li>
          <li>Processing payments (contractual necessity)</li>
          <li>Platform analytics and improvement (consent required)</li>
          <li>Sending administrative and transactional emails (legitimate interest)</li>
        </ul>
      </LegalSection>
      <LegalSection title="3. Retention periods">
        <ul>
          <li>Account data: retained until account deletion + 30-day grace period</li>
          <li>Payment data: 5 years (legal obligation)</li>
          <li>Analytics data: 13 months (CNIL recommendation)</li>
        </ul>
      </LegalSection>
      <LegalSection title="4. Your rights">
        <p>Under the GDPR, you have the following rights:</p>
        <ul>
          <li>Right of access — obtain a copy of your personal data</li>
          <li>Right to rectification — correct inaccurate data</li>
          <li>Right to erasure — request deletion of your account and data</li>
          <li>Right to restriction — limit processing of your data</li>
          <li>Right to portability — receive your data in a structured format</li>
          <li>Right to object — object to processing based on legitimate interest</li>
        </ul>
        <p>To exercise your rights, contact us at <a href="mailto:rgpd@mykurso.fr" className="text-[#ff6b6b]">rgpd@mykurso.fr</a>. We will respond within 30 days.</p>
      </LegalSection>
      <LegalSection title="5. Third parties">
        <p>We may share your data with: Stripe (payments), Brevo (transactional emails), Mixpanel (analytics — consent required), Emergent Labs (hosting infrastructure).</p>
        <p>We do not sell your personal data to third parties.</p>
      </LegalSection>
    </LegalLayout>
  );
}
